type StoryBibleSectionKey = "characters" | "worldbuilding";

export type EntityNavigationPlan = {
  sectionToOpen: StoryBibleSectionKey | null;
  delayMs: number;
  targetId: string | null;
  block: ScrollLogicalPosition;
};

export function getEntityNavigationPlan(
  id: string,
  collapsedSections: Partial<Record<StoryBibleSectionKey, boolean>> = {},
): EntityNavigationPlan {
  if (id.startsWith("character::")) {
    return {
      sectionToOpen: collapsedSections.characters ? "characters" : null,
      delayMs: collapsedSections.characters ? 200 : 0,
      targetId: `story-bible-character-${id.slice("character::".length)}`,
      block: "start",
    };
  }

  if (id.startsWith("worldbuilding::")) {
    return {
      sectionToOpen: collapsedSections.worldbuilding ? "worldbuilding" : null,
      delayMs: collapsedSections.worldbuilding ? 200 : 0,
      targetId: `story-bible-worldbuilding-${id.slice("worldbuilding::".length)}`,
      block: "start",
    };
  }

  return {
    sectionToOpen: null,
    delayMs: 0,
    targetId: null,
    block: "center",
  };
}
